import { FocusOnce, ModalBody, ModalHeader } from "baseui/modal";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import CircleLoader from "components/atoms/CircleLoader";
import CareerService from "services/careers.service";
import RemarksForm from "./RemarksForm";
import UpdateForm from "./RemarksForm/UpdateForm";

export default function Remarks() {
  const dispatch = useAppDispatch();
  const { id, index } = useAppSelector((state) => state.modal.data);
  const { loading } = useAppSelector((state) => state.careers);

  const handleSubmit = async (values: any) => {
    let payload = {
      remarks: values.remarks,
      id: id,
    };
    CareerService.addRemarks(payload, dispatch);
  };
  return (
    <>
      <FocusOnce>
        <ModalHeader>Add Remarks</ModalHeader>
      </FocusOnce>
      <ModalBody>
        {loading && <CircleLoader />}
        <RemarksForm onSubmit={handleSubmit} />
        {id && <UpdateForm index={index} />}
      </ModalBody>
    </>
  );
}
